module.exports = __webpack_public_path__ + "img/image-set-dots.c6d7633a.png";